import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import SVGDocumentDropdown from '@/pages/Library/components/SVGDocumentDropdown'

interface IProps {
  settings: ISVGSettings
  onChange: (val: any, name: string) => void
}

const SvgChartSettingsContentCommonInfoStep = (props: IProps) => {
  return (
    <div className="flex-lines gap8" style={{ paddingRight: '24px' }}>
      <FormField label="Наименование">
        <TextInput
          value={props.settings.title}
          name="title"
          onChange={props.onChange}
          placeHolder="Введите наименование"
        />
      </FormField>
      <FormField label="SVG-Схема">
        <SVGDocumentDropdown
          name="image_id"
          onChange={props.onChange}
          value={props.settings.image_id}
          title="Выберите SVG"
        />
      </FormField>
    </div>
  )
}

export default SvgChartSettingsContentCommonInfoStep
